import React from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';

const BigPlus = () => {
	const navigate = useNavigate();
	return (
		<div className="pb-20 md:pb-0">
			<button
				className="flex justify-center items-center  aspect-ratio-16-9"
				onClick={() => {
					navigate('/livestreaming-CameraRegistration');
				}}
				type="button"
			>
				<div className="w-full video-player-box rounded-lg bg-color">
					<img alt="" className="w-1/6" src="assets/images/plus-big.png" />
				</div>
			</button>
		</div>
	);
};

export default BigPlus;
